import { useActivitySummaryContext } from '@user/features/Activity/ActivitySummary/context'
import { setAnchorElActionCreator } from '@user/features/Activity/ActivitySummary/state'
import { type MouseEvent, useCallback } from 'react'

import { useData } from './useData'

type Props = {
  setAnchorEl: ReturnType<typeof useData>['setAnchorEl']
}

export function useHandlers(props: Props) {
  const { setAnchorEl } = props
  const [, dispatch] = useActivitySummaryContext()

  const onOpen = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
      dispatch(setAnchorElActionCreator(event.currentTarget))
    },
    [dispatch, setAnchorEl],
  )

  const onClose = useCallback(() => {
    setAnchorEl(null)
  }, [setAnchorEl])

  return {
    onOpen,
    onClose,
  }
}
